import React from 'react';
import styles from './emoji-picker-button.module.scss';
import addReactionAsset from '../../../../../assets/img/add-reactions.svg';
import classnames from 'classnames';

export const EmojiPickerButton = ({ onClick, isOpen = false }) => {
  return (
    <div
      className={classnames(styles.addReactionContainer, {
        [styles.selected]: isOpen
      })}
    >
      <img
        src={addReactionAsset}
        onClick={() => {
          onClick && onClick();
        }}
        alt="Add reaction"
      />
    </div>
  );
};
